<!-- Redirect stub — sign-up form now lives inline in LoginComponent -->
<div></div>
